export default "__VITE_ASSET__eNMQ1WrT__";